import React, { Dispatch, SetStateAction, useEffect, useRef } from 'react';
import { CreatePaymentWidgetParams, MountableElement, PAYMENT_METHODS } from 'integrations/payment';
interface CreditCardProps {
  setIsPaymentDataValid: Dispatch<SetStateAction<boolean>>;
  createPaymentWidget: (params: CreatePaymentWidgetParams) => Promise<MountableElement>;
}

export const CreditCard: React.FC<CreditCardProps> = ({
  setIsPaymentDataValid,
  createPaymentWidget
}) => {
  const paymentContainer = useRef<HTMLDivElement>(null);

  const createCheckout = async (): Promise<void> => {
    const onChange = (isValid: boolean): void => {
      setIsPaymentDataValid(isValid);
    };

    const widget = await createPaymentWidget({
      paymentMethodType: PAYMENT_METHODS.Card,
      onChange
    });

    if (paymentContainer.current) {
      widget.mount(paymentContainer.current);
    }
  };

  useEffect(() => {
    createCheckout();
  }, []);

  return (
    <div ref={ paymentContainer }></div>
  );
};
